import { useMutation } from "react-query";
import { createAllergy, deleteAllergy } from "api/customers";

export const useUpdateAllergies = () => {
  const { mutateAsync: addAllergy } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: { allergyType: string } }) =>
      createAllergy(clientId, payload)
  );

  const { mutateAsync: removeAllergy } = useMutation(
    ({ id }: { id: number }) => deleteAllergy(id)
  );

  return { addAllergy, removeAllergy };
};

export default useUpdateAllergies;
